import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import { propostasApi } from '../../api/vendas';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import NegociacaoDetail from './NegociacaoDetail';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function NegociacaoList() {
  useTituloPagina('Negociação');
  const [propostas, setPropostas] = useState([]);
  const [propostaAberta, setPropostaAberta] = useState(null);

  const carregar = useCallback(() => {
    propostasApi.listar({ status_exibicao: 'em_negociacao' }).then(setPropostas).catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  if (propostaAberta) {
    return <NegociacaoDetail propostaId={propostaAberta} onVoltar={() => { setPropostaAberta(null); carregar(); }} />;
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}` }}>
          <span style={{ fontSize: 13, color: COLORS.textMid }}>
            Propostas com item(ns) vendidos abaixo da tabela Promoção, aguardando sua decisão.
          </span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 10 }}>N° Proposta</th>
                <th style={{ padding: 10 }}>Data</th>
                <th style={{ padding: 10 }}>Vendedor</th>
                <th style={{ padding: 10 }}>Cliente</th>
                <th style={{ padding: 10 }}>Valor dos Produtos</th>
                <th style={{ padding: 10 }} />
              </tr>
            </thead>
            <tbody>
              {propostas.map(pr => (
                <tr key={pr.id} onClick={() => setPropostaAberta(pr.id)}
                  style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                  <td style={{ padding: 10 }}>#{pr.numero}</td>
                  <td style={{ padding: 10 }}>{new Date(pr.criado_em).toLocaleDateString('pt-BR')}</td>
                  <td style={{ padding: 10 }}>{pr.vendedor_nome}</td>
                  <td style={{ padding: 10 }}>{pr.cliente_nome}</td>
                  <td style={{ padding: 10 }}>{formatarReais(pr.valor_total)}</td>
                  <td style={{ padding: 10 }}><Badge tom="aviso">Em Negociação</Badge></td>
                </tr>
              ))}
              {propostas.length === 0 && (
                <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma proposta aguardando negociação.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
